import React from 'react';
import CardUI from '../../../widgets/layout/CardUI';
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI';
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI';
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI';
import BadgeUI from '../../../widgets/output/BadgeUI';

const MessageApprovalEmailListUI = ({ context, messages, onUpdateMessageClick }) => (
  <div>
    {
      messages.map((message, i) => (
        <LRTableBodyUI key={i}>
          <CardUI>
            <div className='g_flex_h g_flex_top g_flex_left'>
              <LabelAndValueUI label='Email Recipients'>
                {
                  message.emailToList.map((email, j) =>
                    <span key={j} className='g_flex_v'>{email}</span>
                  )}
              </LabelAndValueUI>
              <span className='g_m_right_100' />
              <span className='g_m_right_100' />
              <LabelAndValueUI label='File Attachments'>
                {
                  message.fileUploadList.map((file, j) =>
                    <span key={j}>{file}</span>
                  )}
              </LabelAndValueUI>
              <span className='g_flex_v g_m_left_auto g_text_right'>
                <LabelAndValueUI label='Updated By'>
                  <span>{message.updatedByUserName || '-'}</span>
                </LabelAndValueUI>
                <LabelAndValueUI label='Sent By'>
                  <span>{message.sentByUserName || '-'}</span>
                </LabelAndValueUI>
                <LabelAndValueUI label='Sent Date'>
                  <span>
                    {message.sentDate
                      ? (() => {
                        const dateValue = isNaN(message.sentDate)
                          ? new Date(`${message.sentDate}T00:00:00`)
                          : new Date(Number(message.sentDate));
                        return dateValue.toLocaleDateString('en-IN', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        });
                      })()
                      : '-'}
                  </span>
                </LabelAndValueUI>

              </span>
            </div>
          </CardUI>
          <LRTableRowUI className='g_flex_top'
            left={<RowLeftUI message={message} />}
            right={<RowRightUI message={message} onUpdateMessageClick={onUpdateMessageClick} />}
          />
        </LRTableBodyUI>
      ))
    }
  </div>
);

const RowLeftUI = ({ message }) => {
  const htmlMessage = (message && message.message) ? message.message.replace(/\n/g, '<br/>') : '';
  return (
    <div
      style={{ whiteSpace: 'pre-line' }}
      dangerouslySetInnerHTML={{ __html: htmlMessage }}
    />
  );
};


const RowRightUI = ({ message, onUpdateMessageClick }) => (
  <div className='g_flex_h'>
    {/* Edit (pencil) icon */}
    {
      message.pendingStatus &&
      <BadgeUI label={message.pendingStatus} />
    }
    {/* <span
      className='icon icon-pencil g_m_left_50'
      onClick={onUpdateMessageClick}
      message-approval-id={message.messageApprovalId}
    /> */}
  </div>
);
export default MessageApprovalEmailListUI;
